import { ETabs } from '../types/Tabs.enum';

export const DASHBOARD_TABS = [
  ETabs.BASIC_INFO,
  ETabs.YOUR_WEBSITE,
  ETabs.PAYMENT_METHODS,
  ETabs.BILLING_HISTORY,
];
